export const GUEST_CART_ID = 'guest-cart-id'
export const RECENTLY_PRODUCT = 'RECENTLY_PRODUCT'
export const FULL_RECENTLY_PRODUCT = 'FULL_RECENTLY_PRODUCT'